export enum CompanyStatements {
  valueStatement1 = 'isUndervaluedBasedOnDCF',
  valueStatement2 = 'isHighlyUndervaluedBasedOnDCF',
  valueStatement3 = 'isUndervaluedOnPERelativeToPeers',
  valueStatement4 = 'isUndervaluedOnPERelativeToMarket',
  valueStatement5 = 'isUndervaluedBasedOnPEG',
  valueStatement6 = 'isUndervaluedBasedOnPB',
  valuationStatement1 = 'isGoodValueComparingPreferredMultipleToPeersAverageValue',
  valuationStatement2 = 'isGoodValueComparingPreferredMultipleToIndustry',
  valuationStatement3 = 'isGoodValueComparingRatioToFairRatio',
  valuationStatement4 = valueStatement1,
  valuationStatement5 = valueStatement2,
  valuationStatement6 = valueStatement5,
  valuationStatement7 = 'isAnalystForecastTrustworthy',
  futureStatement1 = 'isExpectedProfitGrowthAboveRiskFreeRate',
  futureStatement2 = 'isExpectedAnnualProfitGrowthAboveMarket',
  futureStatement3 = 'isExpectedAnnualProfitGrowthHigh',
  futureStatement4 = 'isExpectedRevenueGrowthAboveMarket',
  futureStatement5 = 'isExpectedRevenueGrowthHigh',
  futureStatement6 = 'isReturnOnEquityForecastAboveBenchmark',
  pastStatement1 = 'hasGrownProfitsOverPast5Years',
  pastStatement2 = 'hasProfitGrowthAccelerated',
  pastStatement3 = 'isGrowingFasterThanIndustry',
  pastStatement4 = 'isReturnOnEquityAboveThreshold',
  pastStatement5 = 'hasHighQualityPastEarnings',
  pastStatement6 = 'hasPastNetProfitMarginImprovedOverLastYear',
  healthStatement1 = 'areShortTermLiabilitiesCovered',
  healthStatement2 = 'areLongTermLiabilitiesCovered',
  healthStatement3 = 'isDebtLevelAppropriate',
  healthStatement4 = 'hasDebtReducedOverTime',
  healthStatement5 = 'isDebtCoveredByCashflow',
  healthStatement6 = 'isInterestCoveredByProfit',
  /** Financial institutions */
  alternativeHealthStatement1 = 'hasAnAppropriateLevelOfAssets',
  alternativeHealthStatement2 = 'hasAppropriateBadLoanAllowance',
  alternativeHealthStatement3 = 'hasPrimarilyLowRiskFunding',
  alternativeHealthStatement4 = 'hasAppropriateLoanLevel',
  alternativeHealthStatement5 = 'hasPrimarilyDepositFunding',
  alternativeHealthStatement6 = 'hasAppropriateNonPerformingLoans',
  /** Loss making company */
  lossMakingHealthStatement1 = 'areShortTermLiabilitiesCovered',
  lossMakingHealthStatement2 = 'areLongTermLiabilitiesCovered',
  lossMakingHealthStatement3 = 'isDebtLevelAppropriate',
  lossMakingHealthStatement4 = 'hasDebtReducedOverTime',
  lossMakingHealthStatement5 = 'hasCashRunwayIfStable',
  lossMakingHealthStatement6 = 'hasCashRunwayIfGrowing',

  dividendStatement1 = 'isDividendSignificant',
  dividendStatement2 = 'isDividendYieldTopTier',
  dividendStatement3 = 'isDividendStable',
  dividendStatement4 = 'isDividendGrowing',
  dividendStatement5 = 'isDividendCovered',
  dividendStatement6 = 'isDividendCoveredIn3Years',
  dividendStatement7 = 'isDividendCoveredByFreeCashFlow',

  managementStatement1 = 'isCEOCompensationAppropriate',
  managementStatement2 = 'isCEOCompensationChangeJustified',
  managementStatement3 = 'isManagementTeamSeasoned',
  managementStatement4 = 'isBoardSeasoned',
}
